<div #contentDiv class="max-w-lg mx-auto flex-col h-screen pt-20 min-h-[calc(100vh)]">
  <div class="flex-1 bg-theme-surface rounded-t-3xl min-h-full">
    <div class="flex flex-row pt-6 px-4 pb-4 items-center">
      <div class="mr-3">
        <app-circle-button [icon]="'fa-chevron-left'" size="12" type="solid" fontSize="xl" (onClick)="back()"></app-circle-button>
      </div>
      <div class="ml-2 text-3xl px-4 break-words text-theme-text">{{getString("Kvitton")}}</div>
    </div>

    <div class="px-4">
      <ng-container *ngIf="vm$ | async as vm">
        <div *ngIf="vm.loading" class="px-4 py-6">
          <app-loading-spinner size="lg"></app-loading-spinner>
        </div>

        <div *ngIf="!vm.loading && vm.receipts.length > 0" class="px-4 py-6 text-theme-text">
          <div *ngFor="let receipt of vm.receipts; let last=last">
            <app-base-button baseClass="w-full flex items-center justify-between py-3 tabular-nums" (onClick)="navReceipt(receipt)">
              <div>{{receipt.paid_date}}</div>
              <div class="ml-auto text-right">{{receipt.amount | number:'.2'}} {{currencySymbol}}</div>
            </app-base-button>
            <app-separator *ngIf="!last" [space]="0" class="item-separator"></app-separator>
          </div>

        </div>

        <div *ngIf="!vm.loading && vm.receipts.length === 0" class="px-4 py-6 text-theme-text">
          {{getString("Inga kvitton hittills")}}
        </div>
      </ng-container>
    </div>

  </div>
</div>
